/** Tailwind class fragments keyed by RingsDB `sphere_name` (case-insensitive). */
export function sphereAccentClasses(sphereName) {
  const n = (sphereName || "").trim().toLowerCase();
  if (n === "leadership") {
    return {
      bar: "bg-purple-500",
      chartBar: "bg-purple-500/80",
      header: "text-purple-200",
      chip: "border-purple-500/40 bg-purple-950/60 text-purple-100",
    };
  }
  if (n === "tactics") {
    return {
      bar: "bg-red-500",
      chartBar: "bg-red-500/80",
      header: "text-red-200",
      chip: "border-red-500/40 bg-red-950/60 text-red-100",
    };
  }
  if (n === "spirit") {
    return {
      bar: "bg-sky-500",
      chartBar: "bg-sky-500/80",
      header: "text-sky-200",
      chip: "border-sky-500/40 bg-sky-950/60 text-sky-100",
    };
  }
  if (n === "lore") {
    return {
      bar: "bg-emerald-500",
      chartBar: "bg-emerald-500/80",
      header: "text-emerald-200",
      chip: "border-emerald-500/40 bg-emerald-950/60 text-emerald-100",
    };
  }
  if (n === "neutral") {
    return {
      bar: "bg-slate-400",
      chartBar: "bg-slate-400/80",
      header: "text-slate-200",
      chip: "border-slate-500/50 bg-slate-800/80 text-slate-100",
    };
  }
  return {
    bar: "bg-slate-500",
    chartBar: "bg-slate-500/80",
    header: "text-slate-300",
    chip: "border-slate-600 bg-slate-800/90 text-slate-200",
  };
}

export function hasCardStat(value) {
  return value != null && value !== "";
}
